import React from 'react';
import { tableOfContentsPropTypes } from '@Theme/natucare/modules/Article/components/TableOfContents/TableOfContentsPropTypes';
import * as styles from './TableOfContents.module.scss';
const TableOfContents = ({
  heading,
  links
}) => {
  if (!heading && !links) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, heading && /*#__PURE__*/React.createElement("div", {
    className: styles.rootHeading
  }, heading), links && /*#__PURE__*/React.createElement("ol", {
    className: styles.rootList
  }, links.map((item, index) => /*#__PURE__*/React.createElement("li", {
    className: styles.rootListItem,
    key: index
  }, /*#__PURE__*/React.createElement("a", {
    className: styles.rootListItemLink,
    href: item.href
  }, item.label)))));
};
export default TableOfContents;